import axios from "axios";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { InputGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/esm/Tab";
import Tabs from "react-bootstrap/esm/Tabs";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { Store } from "../Store";
import Gorsel from "../components/Gorsel";
import LoadingBox from "../components/LoadingBox";
import Option from "../components/Option";
import ProductQuestions from "../components/ProductQuestions";
import ProductSampleFeatures from "../components/ProductSampleFeatures";
import { default as config } from "../config.json";
import useSampleProductsAndCategories from "../hooks/useSampleProductsAndCategories";
import { capitalize, getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loadingCreate: true };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loadingCreate: false,
      };
    case "CREATE_FAIL":
      return { ...state, loadingCreate: false };
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    case "UPLOAD_REQUEST":
      return { ...state, loadingUpload: true, errorUpload: "" };
    case "UPLOAD_SUCCESS":
      return {
        ...state,
        loadingUpload: false,
        errorUpload: "",
      };
    case "UPLOAD_FAIL":
      return { ...state, loadingUpload: false, errorUpload: action.payload };

    case "DELETE_FILE_REQUEST":
      return { ...state, dele: true, loadingDeletingImage: true };
    case "DELETE_FILE_SUCCESS":
      return {
        ...state,
        loadingDeletingImage: false,
      };
    case "DELETE_FILE_FAIL":
      return { ...state, loadingDeletingImage: false };

    default:
      return state;
  }
};
export default function ProductSampleEditScreen(props) {
  const { product, setShowProductEditor } = props;
  const params = useParams();

  const { state } = useContext(Store);
  const { userInfo, allCategories } = state;
  const [{ loadingUpdate, loadingCreate }, dispatch] = useReducer(reducer, {
    loadingDeletingImage: false,
    loadingUpload: false,
    loadingCreate: false,
  });
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState(product.tags || []);
  const [image, setImage] = useState("");
  const [isStock, setIsStock] = useState(false);
  const [unit, setUnit] = useState("ADET-1");
  const [formValidated, setFormValidated] = useState(false);
  const [features, setFeatures] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [activeTab, setActiveTab] = useState(props.activeTab || "main");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategoriesNames, setSelectedCategoriesNames] = useState([]);
  const [stockInputs, setStockInputs] = useState([]);
  const navigate = useNavigate();

  const [
    loadingProducts,
    errorLoadingProducts,
    setLoadProducts,
    setLoadCategories,
    setLoadLeafCategories,
  ] = useSampleProductsAndCategories();

  const addHashtag = () => {
    const inputElement = document.getElementById("hashtag-input");
    if (inputElement && inputElement.value.trim()) {
      const newHashtag = "#" + inputElement.value.trim();
      if (!tags.includes(newHashtag)) {
        setTags([...tags, newHashtag]);
      }
      inputElement.value = "";
    }
  };

  useEffect(() => {
    if (product._id) {
      setName(product.name);
      setDescription(product.description);
      setTags(product.tags || []);
      setImage(product.image);
      setIsStock(product.isStock);
      setUnit(product.unit);
      setFeatures(product.features ? product.features : []);
      setQuestions(product.questions || []);

      const productCategories = allCategories.filter(
        (c) => c.products.filter((p) => p._id === product._id).length > 0
      );

      setSelectedCategories(productCategories.map((c) => c._id));
      setSelectedCategoriesNames(productCategories.map((c) => c.name));
    }
  }, [product, allCategories]);

  const submitHandler = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      setFormValidated(true);
      return;
    }
    if (e) {
      e.preventDefault();
    }

    try {
      dispatch({ type: "UPDATE_REQUEST" });
      await axios.put(
        `/api/productsamples/${product._id}`,
        {
          _id: product._id,
          name,
          description,
          tags: tags,
          expenseSubType:
            selectedCategoriesNames.length > 0
              ? selectedCategoriesNames[0]
              : "DIGER",
          image: image || config.default_image,
          isStock,
          unit,
          features: features.filter((f) => f._id || !f.deleted),
          categories: selectedCategories,
          questions: questions,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );

      setLoadProducts(true);
      setLoadCategories(true);
      setLoadLeafCategories(true);

      dispatch({
        type: "UPDATE_SUCCESS",
      });
      setShowProductEditor(false);

      toast.success("Ürün başarılı bir şekilde güncellendi");
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  const createHandler = async (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      setFormValidated(true);
      return;
    }
    e.preventDefault();

    try {
      dispatch({ type: "CREATE_REQUEST" });
      const { data } = await axios.post(
        "/api/productsamples",
        {
          name,
          description,
          tags: tags,
          image: image || config.default_image,
          isStock,
          unit,
          features: features.filter((f) => f._id || !f.deleted),
          categories: selectedCategories,
          questions: questions,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );
      setLoadProducts(true);
      setLoadCategories(true);
      setLoadLeafCategories(true);
      toast.success("Ürün başarılı bir şekilde oluşturuldu!");
      dispatch({ type: "CREATE_SUCCESS" });
      setShowProductEditor(false);
    } catch (err) {
      toast.error(getError(err));
      dispatch({
        type: "CREATE_FAIL",
      });
    }
  };

  const handleHashtagChange = (e) => {
    if (e.key === "Enter" && e.target.value) {
      e.preventDefault();
      const newHashtag = "#" + e.target.value.trim();
      if (!tags.includes(newHashtag)) {
        setTags([...tags, newHashtag]);
      }
      e.target.value = "";
    }
  };

  const removeHashtag = (hashtag) => {
    setTags(tags.filter((h) => h !== hashtag));
  };

  const productFeaturesChangeHandler = (e, id, prop, i) => {
    if (!id) {
      const featuresCopied = [...features.filter((a) => !a.deleted)];
      if (prop === "name") {
        featuresCopied[i].name = e.target.value;
      }
      setFeatures([...featuresCopied]);
      return;
    }
    const lastFeautures = features
      .filter((f) => !f.deleted)
      .map((f, i) => {
        if (f._id === id) {
          if (prop === "name") {
            f.name = e.target.value;
          }
        }
        return f;
      });
    setFeatures([...lastFeautures]);
  };

  const productQuestionAnswerChangeHandler = (e, ai, q, qi, field) => {
    const question = { ...q };
    const answers = question.answers;

    const answersDeleted = [...answers.filter((f) => f.deleted)];

    question.answers = [...answers.filter((f) => !f.deleted)].map((a, i) => {
      if (i === ai) {
        const ans = { ...a };
        ans[field] = e.target.value;
        return ans;
      } else {
        return { ...a };
      }
    });
    question.answers.push(...answersDeleted);

    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);
    const result = questionsNotDeleted.map((q, i) => {
      if (i === qi) {
        return { ...question };
      } else {
        return { ...q };
      }
    });
    result.push(...questionsDeleted);
    setQuestions(result);
  };

  const productFeaturesAddHandler = () => {
    setFeatures([...features, { name: "", price: null, deleted: false }]);
  };

  const productQuestionAnswerAddHandler = (i, question) => {
    const questionsRe = [...questions];
    questionsRe[i] = {
      ...question,
      answers: [...question.answers, { answer: "", deleted: false }],
    };

    setQuestions(questionsRe);
  };
  const productQuestionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      question: e.target.value,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionMultiOptionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      multi: e.target.checked,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionCompulsoryOptionChangeHandler = (e, i, question) => {
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);

    questionsNotDeleted[i] = {
      ...question,
      compulsory: e.target.checked,
    };
    questionsNotDeleted.push(...questionsDeleted);
    setQuestions(questionsNotDeleted);
  };

  const productQuestionDeleteHandler = (id, i) => {
    if (!id) {
      const questionsRe = [...questions.filter((f) => !f.deleted)];
      const questionsDeleted = [...questions.filter((f) => f.deleted)];
      if (i + 1 === questionsRe.length) {
        setQuestions([...questions.slice(0, i), ...questionsDeleted]);
      } else {
        setQuestions([
          ...questionsRe.slice(0, i),
          ...questionsRe.slice(i + 1),
          ...questionsDeleted,
        ]);
      }
      return;
    } else {
      const questionsDeleted = [...questions.filter((f) => f.deleted)];
      const questionsRe = [...questions.filter((f) => !f.deleted)].map((q) => {
        if (q._id === id) {
          return { ...q, deleted: true };
        } else {
          return { ...q };
        }
      });
      setQuestions([...questionsRe, ...questionsDeleted]);
    }
  };

  const productFeaturesDeleteHandler = (id, i) => {
    if (!id) {
      const copyOfFeatures = [...features.filter((f) => !f.deleted)];
      copyOfFeatures[i].deleted = true;
      setFeatures([...copyOfFeatures]);
      return;
    }
    setFeatures([
      ...features.map((f, index) => {
        if (f._id === id) {
          return { ...f, deleted: true };
        } else {
          return { ...f };
        }
      }),
    ]);
  };

  const productQuestionAnswerDeleteHandler = (answerId, answerIndex, q, qi) => {
    const question = { ...q };
    const answers = question.answers;
    if (!answerId) {
      const answersRe = [...answers.filter((f) => !f.deleted)];
      const answersDeleted = [...answers.filter((f) => f.deleted)];
      if (answerIndex + 1 === answersRe.length) {
        question.answers = [...answers.slice(0, answerIndex)];
      } else {
        question.answers = [
          ...answersRe.slice(0, answerIndex),
          ...answersRe.slice(answerIndex + 1),
        ];
      }
      question.answers.push(...answersDeleted);
    } else {
      const answersDeleted = [...answers.filter((f) => f.deleted)];
      question.answers = [...answers.filter((f) => !f.deleted)].map((a) => {
        if (a._id === answerId) {
          return { ...a, deleted: true };
        } else {
          return { ...a };
        }
      });
      question.answers.push(...answersDeleted);
    }
    const questionsDeleted = questions.filter((q) => q.deleted);
    const questionsNotDeleted = questions.filter((q) => !q.deleted);
    const result = questionsNotDeleted.map((q, i) => {
      if (i === qi) {
        return { ...question };
      } else {
        return { ...q };
      }
    });
    result.push(...questionsDeleted);
    setQuestions(result);
  };

  return (
    <Container className="small-container">
      <Helmet>
        <title>{name}</title>
      </Helmet>

      <Form
        onSubmit={!product._id ? createHandler : submitHandler}
        noValidate
        validated={formValidated}
      >
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="main" title="Ürün Bilgileri">
            <Form.Group className="mb-3">
              <Form.Label>Adı</Form.Label>
              <Form.Control
                placeholder="Ürün Adı"
                value={name}
                onChange={(e) => setName(capitalize(e.target.value))}
                required
              />
              <Form.Control.Feedback type="invalid">
                Lutfen ad alanini bos birakmayiniz
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                placeholder="Ürün Açıklaması"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <div className="d-flex flex-wrap">
                {tags.map((hashtag, index) => (
                  <div key={index} className="badge bg-light m-1">
                    <span className="text-black">{hashtag}</span>
                    <Button
                      variant="link"
                      className="text-black ms-2"
                      onClick={() => removeHashtag(hashtag)}
                    >
                      &times;
                    </Button>
                  </div>
                ))}
              </div>
              <div className="d-flex mt-2">
                <InputGroup>
                  <Form.Control
                    id="hashtag-input"
                    type="text"
                    placeholder="Yeni etiket ekle"
                    onKeyDown={handleHashtagChange}
                  />
                  <Button variant="primary" onClick={addHashtag}>
                    Etiket Ekle
                  </Button>
                </InputGroup>
              </div>
            </Form.Group>

            <div className="mb-3">
              <div className="mb-2">
                <Button
                  className=" mb-0"
                  onClick={() => productFeaturesAddHandler()}
                >
                  <i className="fas fa-plus"></i> Çeşit Ekle
                </Button>
              </div>
              <ProductSampleFeatures
                productFeaturesAddHandler={productFeaturesAddHandler}
                productFeaturesChangeHandler={productFeaturesChangeHandler}
                productFeaturesDeleteHandler={productFeaturesDeleteHandler}
                features={features}
              ></ProductSampleFeatures>
            </div>

            <Gorsel
              image={image}
              setImage={setImage}
              entityId={product._id}
              entityName={"productsample"}
            ></Gorsel>

            <Form.Group className="mb-3">
              <Form.Label>Kategoriler</Form.Label>
              <div className="mb-3">
                <ReactSelect
                  placeholder="Kategori Seç"
                  options={allCategories
                    .filter((c) => !c.categories || c.categories.length === 0)
                    .map((c) => {
                      return { value: c._id, label: c.name };
                    })}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={(selected) => {
                    setSelectedCategories(selected.map((entry) => entry.value));
                    setSelectedCategoriesNames(
                      selected.map((entry) => entry.label)
                    );
                  }}
                  allowSelectAll={true}
                  value={allCategories
                    .filter((c) => selectedCategories.includes(c._id))
                    .map((c) => {
                      return { value: c._id, label: c.name };
                    })}
                />
              </div>
            </Form.Group>
          </Tab>

          <Tab eventKey="questions" title="Soru Oluşturma">
            <Button
              className="mb-3"
              onClick={() => {
                setQuestions([
                  ...questions,
                  {
                    question: "",
                    multi: false,
                    compulsory: false,
                    deleted: false,
                    answers: [
                      { answer: "", deleted: false },
                      { answer: "", deleted: false },
                    ],
                  },
                ]);
              }}
            >
              <i className="fas fa-plus"></i> {"Soru Ekle"}
            </Button>

            {questions
              .filter((q) => !q.deleted)
              .map((q, i) => (
                <ProductQuestions
                  key={q._id ? q._id : i + ""}
                  productQuestionCompulsoryOptionChangeHandler={
                    productQuestionCompulsoryOptionChangeHandler
                  }
                  productQuestionMultiOptionChangeHandler={
                    productQuestionMultiOptionChangeHandler
                  }
                  productQuestionDeleteHandler={productQuestionDeleteHandler}
                  productQuestionChangeHandler={productQuestionChangeHandler}
                  productQuestionAnswerChangeHandler={
                    productQuestionAnswerChangeHandler
                  }
                  productQuestionAnswerDeleteHandler={
                    productQuestionAnswerDeleteHandler
                  }
                  productQuestionAnswerAddHandler={
                    productQuestionAnswerAddHandler
                  }
                  question={q}
                  questionIndex={i}
                ></ProductQuestions>
              ))}
          </Tab>
        </Tabs>

        <div className="mb-3 mt-3">
          <Button disabled={loadingUpdate || loadingCreate} type="submit">
            <i className="fa fa-save"></i>&nbsp; Kaydet
          </Button>
          &nbsp;
          <Button
            variant="light"
            className="text-danger border-danger"
            disabled={loadingUpdate || loadingCreate}
            onClick={() => {
              setShowProductEditor(false);
            }}
          >
            Kapat
          </Button>
          {loadingUpdate && <LoadingBox></LoadingBox>}
        </div>
      </Form>
    </Container>
  );
}
